// extracted by mini-css-extract-plugin
export var phone = "_3z-0";
export var phoneDragging = "_3z-1";